<template>
  <div>
    <top-bar title="Meus pontos"/>
    <loading v-show="load" :fullscrean="true" text="Carregando os dados"/>
    <div v-show="!load">
      <div class="container" style="max-width: 600px">
        <div class="border mb-3 rounded-lg bg-white">
          <div class="d-flex justify-content-between p-3">
            <h6 class="m-0">SALDO</h6>
            <h6 class="m-0 font-weight-bolder text-primary">
              <span v-if="saldo > 0">{{saldo > 1 ? saldo + ' PONTOS' : saldo + ' PONTO'}}</span>
              <span v-else>0</span>
            </h6>
          </div>
        </div>
        <div>
          <card-info title="Clube de Vantagens" :link="url + '/promocoes?aba=clube'" icon="pontos" icon-pos="fa-angle-right">
            <div class="small">Conheça os benefícios para resgatar</div>
          </card-info>
        </div>
        <modal-menu :menus="menus" :selected="menu" left="true" @changeMenu="toggleMenu" class="mt-4 mb-0"/>
        <div>
          <div class="mb-4">
            <div class="container-pontos" v-if="pontos.length">
              <div class="d-flex align-items-center border-bottom pb-2 mb-2" v-for="p in pontos" v-if="p.pontos != '0'">
                <div class="mr-3">
                  <i class="fa fa-exclamation-circle text-warning" v-if="p.validade"></i>
                  <i class="fa fa-plus-circle text-success" v-else-if="p.pontos > 0"></i>
                  <i class="fa fa-minus-circle text-danger" v-else></i>
                </div>
                <div>
                  <b :class="p.pontos > 0 ? 'text-dark' : 'text-danger'">{{p.pontos}} {{p.pontos === '1' || p.pontos === '-1' ? 'ponto' : 'pontos' }}</b> - <span class="small text-muted mr-2">{{p.data_ponto}}</span>
                  <div class="small">{{p.titulo}}</div>
                  <div class="badge badge-warning" v-if="p.validade">Expira em: {{ p.validade }} dias</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-5 text-center" v-if="!pontos.length">
          <div class="text-center" style="padding-top: 33px" v-if="menu === 1">
            <icon name="pontos" size="38" class="text-primary"/>
            <h6 class="mt-3 mb-0">Você ainda não pontou!</h6>
            <p>Conheça o nosso Clube de Vantagens</p>
            <router-link :to="url + '/promocoes?aba=clube'" class="btn btn-outline-primary">Saiba Mais</router-link>
          </div>
          <div v-else>
            <h6 class="mt-3 mb-0">Você não possui nenhum ponto expirando</h6>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {TheMask} from 'vue-the-mask';
  import LoginFacebook from '../components/auth/LoginFacebook';
  import Loading from "../components/Loading";
  import CardInfo from "../components/CardInfo";
  import Icon from "../components/Icon";
  import ModalMenu from "../components/ModalMenu";
  import TopBar from "../components/TopBar";

  export default {
    name: 'Perfil',
    components: {TopBar, ModalMenu, Icon, CardInfo, Loading, TheMask, LoginFacebook},
    data() {
      return {
        token: localStorage.getItem('token'),
        load: true,
        pontos: [],
        saldo: 0,
        menu: 1,
        menus: [
          { nome: 'Extrato', active: true },
          { nome: 'Expirando', active: true }
        ],
      }
    },

    methods: {
      buscarPontos() {
        this.load = true;
        let pars = '?historico=true';

        if (this.menu === 2) {
          pars += '&expirar=true';
        }

        this.$http.get(this.$store.state.base_url + this.token + '/meus-pontos' + pars)
          .then(response => {
            this.load = false;

            if (response.data) {
              const data = response.data;
              this.pontos = data.pontos || [];
              this.saldo = parseInt(data.saldo);
            }

          }, res => {
            this.load = false;
          });
      },

      toggleMenu(m) {
        this.menu = m;
        this.buscarPontos();
      }
    },

    created() {
      document.body.classList.remove("modal-open");

      if (this.token) {
        this.buscarPontos();
        // this.load = false;
      } else {
        this.$router.push(this.url + '/perfil/login');
      }
    },

    mounted() {
      window.scrollTo(0,0);
    },

    computed: {
      url() {
        return this.$store.state.url
      }
    }
  }
</script>
